import React from 'react';
import createCategoryRoute from '../utils/category-page';

import CategoryPage from '../components/common/CategoryPage';

import { selectGenre } from '../selectors/genre';
import { loadGenre } from '../actions/genre';

const route = createCategoryRoute({
  categorySelector: selectGenre,
  categoryLoader: loadGenre,
  facetType: 'genres',
  contextFacet: 'Genre',
  baseRoute: '/genres',
});

const Genre = ({ ...props }) => {
  return <CategoryPage {...props} />;
};

export default route(Genre);
